export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FacultyCard.vue?vue&type=template&id=5a6bbc0f"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultyCard.vue?vue&type=template&id=5a6bbc0f
// module id = 400
// module chunks = 0